<div class="row">
    <div *ngIf="destinationSelected!=null">
        <h6>Bodegas Asignadas</h6>
    </div>

    <div>
        <div *ngIf="destinationsWarehouse.length === 0">
            <p class="muted" *ngIf="destinationSelected!=null">
                <i class="fa fa-circle-info"></i> No se tiene detalles, debes agregar.
            </p>
            <p class="muted" *ngIf="destinationSelected==null">
                <i class="fa fa-circle-info"></i> Debe seleccionar un destino.
            </p>
        </div>
        <div class="row">
            <div *ngIf="destinationSelected!=null">
                <h5>Detalles</h5>
            </div>
            <!-- <div class="row" id="options-other-filters" *ngIf="destinationSelected">
                <div class="col-sm form-group">
                    <label for="filterVendors" class="form-label">Filtrar</label>
                    <div class="input-group input-group-sm">
                        <input
                            type="text"
                            id="filter"
                            [(ngModel)]="filterWord"
                            (input)="onInputChange($event)"
                            placeholder="Filtra pedidos por usuario o bodega"
                            name="filter"
                            class="form-control"
                        />
                        <button class="btn btn-primary" (click)="searching()">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </div> -->
            <div class="row" *ngIf="destinationSelected!=null">
                <div class="col form-group">
                    <label for="date" class="form-label">Fecha</label>
                    <div class="input-group input-group-sm">
                        <input
                            type="date"
                            id="date"
                            [(ngModel)]="selectedDate"
                            (change)="getDestinationWarehouse()"
                            placeholder="Filtra pedidos por usuario o bodega"
                            name="filter"
                            class="form-control"
                        />
                    </div>
                </div>
            </div>
            <div class="mb-4" *ngIf="destinationsWarehouse.length > 0">
                <table class="table table-striped table-responsive">
                    <thead>
                        <tr class="tr-middle limit-td">
                            <th class="text-left">Bodega</th>
                            <th class="text-left">Quien Asigno</th>
                            <th class="text-right">Fecha y Hora (Inicio - Fin)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!loading">
                            <ng-container *ngFor="let item of pagination.filter">
                                <tr>
                                    <td class="text-left">
                                        {{item.warehouseData.name}}
                                    </td>
                                    <td class="text-left">
                                        {{item.firstname + " " + item.lastname}}
                                    </td>
                                    <td class="text-right">
                                        <div class="d-flex flex-col">
                                            <span class="font-weight-bold">{{item.effectiveDate | date:'dd-MM-YYYY HH:mm'}}</span>
                                            <span class="font-weight-semibold text-secondary">{{item.expirationDate | date:'dd-MM-YYYY HH:mm'}}</span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <tr class="tr-middle" *ngIf="loading">
                            <td colspan="4">
                                <app-loading-animation [height]="'5rem'"></app-loading-animation>
                                <p class="display-6">Cargando</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <app-pagination-custom [elements]="pagination"></app-pagination-custom>
            </div>
        </div>
    </div>
</div>
